import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { PackagePurchaseStep } from 'types';

export type PackagesShopStore = {
  isPackagesShopLoading: boolean;
  isAuthRedirection: boolean;
  step: PackagePurchaseStep;
};

const initialState: PackagesShopStore = {
  isPackagesShopLoading: false,
  isAuthRedirection: false,
  step: PackagePurchaseStep.PACKAGES_LIST
};

export const packagesShopSlice = createSlice({
  name: 'packagesShop',
  initialState,
  reducers: {
    setPackagesShopLoader: (state, action: PayloadAction<boolean>) => {
      state.isPackagesShopLoading = action.payload;
    },
    setIsAuthRedirection: (state, action: PayloadAction<boolean>) => {
      state.isAuthRedirection = action.payload;
    },
    setStep: (state, action: PayloadAction<PackagePurchaseStep>) => {
      state.step = action.payload;
    }
  }
});

export const { setPackagesShopLoader, setStep, setIsAuthRedirection } =
  packagesShopSlice.actions;

export default packagesShopSlice.reducer;
